"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STAMPED_FOIL_TAG_PREFIX = exports.STAMPED_FOIL_IMAGE_TAGS = void 0;
var STAMPED_FOIL_TAG_PREFIX = exports.STAMPED_FOIL_TAG_PREFIX = 'STAMP_FOIL_';
var STAMPED_FOIL_IMAGE_TAGS = exports.STAMPED_FOIL_IMAGE_TAGS = {
  gold: 'STAMP_FOIL_BRIGHT_GOLD',
  'glittery-gold': 'STAMP_FOIL_GLITTERY_GOLD',
  'rose-gold': 'STAMP_FOIL_ROSE_GOLD',
  bronze: 'STAMP_FOIL_BRONZE',
  black: 'STAMP_FOIL_BLACK',
  'bright-silver': 'STAMP_FOIL_BRIGHT_SILVER',
  'glittery-silver': 'STAMP_FOIL_GLITTERY_SILVER',
  'ice-blue': 'STAMP_FOIL_ICE_BLUE',
  blue: 'STAMP_FOIL_BLUE',
  white: 'STAMP_FOIL_WHITE',
  silver: 'STAMP_FOIL_SILVER',
  'matte-black': 'STAMP_FOIL_MATTE_BLACK'
};